// App.jsx - 메인 파일
import React from 'react';
import ClubInfosMain from './club_infos/ClubInfosMain';

interface ClubInfosPageProps {
  id?: string | number;
}

function ClubInfosPage(props: ClubInfosPageProps = {}) {
  return (
    <div className="w-full min-h-screen">
      <ClubInfosMain id={props.id} />
    </div>
  );
}

export default ClubInfosPage;
